import { render, staticRenderFns } from "./SegmentationInsights.vue?vue&type=template&id=483db058&scoped=true"
import script from "./SegmentationInsights.vue?vue&type=script&lang=js"
export * from "./SegmentationInsights.vue?vue&type=script&lang=js"
import style0 from "./SegmentationInsights.vue?vue&type=style&index=0&id=483db058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483db058",
  null
  
)

export default component.exports